import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapsPanelComponent } from './maps-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [MapsPanelComponent],
  exports: [MapsPanelComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
})
export class MapsPanelModule { }
